import { render, staticRenderFns } from "./page_chart_table_symptom.vue?vue&type=template&id=0a6b4769&scoped=true"
import script from "./page_chart_table_symptom.vue?vue&type=script&lang=js"
export * from "./page_chart_table_symptom.vue?vue&type=script&lang=js"
import style0 from "./page_chart_table_symptom.vue?vue&type=style&index=0&id=0a6b4769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b4769",
  null
  
)

export default component.exports